import { StyleSheet } from 'react-native';

import { THEME } from '../../reactor/common';

const { UNIT } = THEME;

export default StyleSheet.create({
  imageArrow: {
    width: UNIT * 2.8,
    height: UNIT * 2,
  },
});
